export default __webpack_public_path__ + "427ec99f202a3698b7e757b887a0539e.png";